import React from 'react'
import Divider from '@mui/material/Divider';
import { AgGridReact } from "ag-grid-react";
import { useState } from 'react';
import { useNavigate } from "react-router-dom";

function PatientLabReports() {
    const navigate = useNavigate();
  return (
    <>
    <main className="bg-white" style={{ width: "100%" }}>
      <div className="row p-3">
        <div className="col-12">
          <div className="p-2 d-flex align-items-center justify-content-between">
            <h4 className="">Lab Reports</h4>
          </div>
        </div>

        <div className="col-12 mb-2">
          <div className="position-relative p-2">
            <input
              style={{ height: "2.5rem", padding: "0px 1.8rem" }}
              type="text"
              className="form-control"
              placeholder="Search a doctor or medical test"
            />
            <div
              className="position-absolute"
              style={{ top: "1.1rem", left: "1rem" }}
            >
              <i class="fa-solid fa-magnifying-glass"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="row p-3">
        <div className="col-12 mb-1">
          <span className="p-2">TODAY</span>
        </div>

        <div className="col-12 col-md-6 mb-2">
          <div className="p-2">
            <div className="p-3 rounded" style={{ background: "#FAFBFD" }}>
              <div className="d-flex flex-column">
                <span style={{ color: "#636D73", fontSize: "14px" }}>
                  Assigned Doctor{" "}
                  <span style={{ color: "#2662F0" }}>Dr. Lalitha</span>
                </span>
                <hr style={{ background: "#A2C0D4" }} />
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                  <div className="d-flex flex-column">
                    <span className="fw-semibold">
                      Cephalin-cholesterol flocculation
                    </span>
                    <small>2 hours ago</small>
                  </div>

                  <button onClick={() => navigate("/ViewPatientLabReports")}
                    className="rounded-5 border-0"
                    style={{
                      color: "#028391",
                      padding: ".4rem .8rem",
                      background: "#fff",
                      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                    }}
                  >
                    View report
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 mb-2">
          <div className="p-2">
            <div className="p-3 rounded" style={{ background: "#FAFBFD" }}>
              <div className="d-flex flex-column">
                <span style={{ color: "#636D73", fontSize: "14px" }}>
                  Assigned Doctor{" "}
                  <span style={{ color: "#2662F0" }}>
                    Dr. Revanth
                  </span>
                </span>
                <hr style={{ background: "#A2C0D4" }} />
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                  <div className="d-flex flex-column">
                    <span className="fw-semibold">Mammography</span>
                    <small>2 hours ago</small>
                  </div>

                    <button onClick={() => navigate("/ViewPatientLabReports")}
                    className="rounded-5 border-0"
                    style={{
                      color: "#028391",
                      padding: ".4rem .8rem",
                      background: "#fff",
                      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                    }}
                  >
                    View report
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 mb-2">
          <div className="p-2">
            <div className="p-3 rounded" style={{ background: "#FAFBFD" }}>
              <div className="d-flex flex-column">
                <span style={{ color: "#636D73", fontSize: "14px" }}>
                  Assigned Doctor{" "}
                  <span style={{ color: "#2662F0" }}>
                    Dr. Shanthi
                  </span>
                </span>
                <hr style={{ background: "#A2C0D4" }} />
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                  <div className="d-flex flex-column">
                    <span className="fw-semibold">Amniocentesis</span>
                    <small>3 hours ago</small>
                  </div>

                  <button onClick={() => navigate("/ViewPatientLabReports")}
                    className="rounded-5 border-0"
                    style={{
                      color: "#028391",
                      padding: ".4rem .8rem",
                      background: "#fff",
                      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                    }}
                  >
                    View report
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 mb-2">
          <div className="p-2">
            <div className="p-3 rounded" style={{ background: "#FAFBFD" }}>
              <div className="d-flex flex-column">
                <span style={{ color: "#636D73", fontSize: "14px" }}>
                  Assigned Doctor{" "}
                  <span style={{ color: "#2662F0" }}>Dr. Srinivas</span>
                </span>
                <hr style={{ background: "#A2C0D4" }} />
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                  <div className="d-flex flex-column">
                    <span className="fw-semibold">
                      Magnetic resonance spectroscopy
                    </span>
                    <small>3 hours ago</small>
                  </div>

                    <button onClick={() => navigate("/ViewPatientLabReports")}
                    className="rounded-5 border-0"
                    style={{
                      color: "#028391",
                      padding: ".4rem .8rem",
                      background: "#fff",
                      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                    }}
                  >
                    View report
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 mb-2">
          <div className="p-2">
            <div className="p-3 rounded" style={{ background: "#FAFBFD" }}>
              <div className="d-flex flex-column">
                <span style={{ color: "#636D73", fontSize: "14px" }}>
                  Assigned Doctor{" "}
                  <span style={{ color: "#2662F0" }}>Dr. vinnu</span>
                </span>
                <hr style={{ background: "#A2C0D4" }} />
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                  <div className="d-flex flex-column">
                    <span className="fw-semibold">
                      Esophagogastroduodenoscopy
                    </span>
                    <small>4 hours ago</small>
                  </div>

                    <button onClick={() => navigate("/ViewPatientLabReports")}
                    className="rounded-5 border-0"
                    style={{
                      color: "#028391",
                      padding: ".4rem .8rem",
                      background: "#fff",
                      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                    }}
                  >
                    View report
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 mb-2">
          <div className="p-2">
            <div className="p-3 rounded" style={{ background: "#FAFBFD" }}>
              <div className="d-flex flex-column">
                <span style={{ color: "#636D73", fontSize: "14px" }}>
                  Assigned Doctor{" "}
                  <span style={{ color: "#2662F0" }}>Dr. Rishav</span>
                </span>
                <hr style={{ background: "#A2C0D4" }} />
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                  <div className="d-flex flex-column">
                    <span className="fw-semibold">
                      Positron emission tomography
                    </span>
                    <small>4 hours ago</small>
                  </div>

                    <button onClick={() => navigate("/ViewPatientLabReports")}
                    className="rounded-5 border-0"
                    style={{
                      color: "#028391",
                      padding: ".4rem .8rem",
                      background: "#fff",
                      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                    }}
                  >
                    View report
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </>
  )
}

export default PatientLabReports